import { z } from "zod"

export const rulePolicySettingsFormDefaultValues = {
  checkin_policy: "",
  refund_policy: "",
  rules: "",
  tos_requires_signature: false, 
}

export const RulePolicySettingsSchema = z.object({
  checkin_policy: z.string().nullable().optional(),
  refund_policy: z.string().nullable().optional(),
  rules: z.string().nullable().optional(),
  tos_requires_signature: z.boolean().optional(),
})

export type RulePolicySettingsType = z.infer<typeof RulePolicySettingsSchema>
